var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('quill-editor',{key:_vm.id,ref:"myQuillEditor",attrs:{"options":_vm.editorOption,"id":_vm.id,"instanceName":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }